const { filter, find } = require('lodash');

class SelectedFiltersController {
    constructor() {
        this.selectedFiltersWithoutCategory = [];
    }

    $onInit() {
        this.showSelectedTags = this.showSelectedTags === undefined ? true : this.showSelectedTags;
    }

    $onChanges() {
        if (this.selectedFilters) {
            // removed category filter from selected filters object to remove category filter from selected filter tags
            this.selectedFiltersWithoutCategory = this.selectedFilters.filters && this.selectedFilters.filters.length > 0 ? filter(this.selectedFilters.filters, selectedFilter => selectedFilter.Key !== 'Category') : [];
        }
        if (this.availableFilters) {
            this.selectedFiltersWithoutCategory.forEach((selectedFilter) => {
                selectedFilter.Items.forEach((filterOption) => {
                    filterOption.Count = 0;
                });
                const matchingAvailableFacet = find(this.availableFilters, availableFilter => availableFilter.Name === selectedFilter.Key);

                if (matchingAvailableFacet != null) {
                    selectedFilter.Items.forEach((filterOption) => {
                        matchingAvailableFacet.ResultsGrouped.some((resultGroup) => {
                            const matchingFilterOption = find(resultGroup.Filters, availableFilter => availableFilter.Term === filterOption.Term);
                            if (matchingFilterOption != null) {
                                filterOption.Count = matchingFilterOption.Count;
                            }
                            return matchingFilterOption != null;
                        });
                    });
                }
            });
        }
    }
}

const selectedFiltersComponentDefinition = {
    bindings: {
        totalRecordCount: '<',
        selectedFilters: '<',
        availableFilters: '<',
        onToggleFilter: '&',
        clearAllFilters: '&',
        showSelectedTags: '<?',
    },
    controller: SelectedFiltersController,
    template: require('./selected-filters.component.html').trim(),
};

module.exports = {
    SelectedFiltersController,
    selectedFiltersComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/tiles/filter/selected-filters.component.js